export default __webpack_public_path__ + "static/media/bulma2.87d0a4b0.png";